import { render } from "./DataQualitySection.vue?vue&type=template&id=4146bb34&scoped=true"
import script from "./DataQualitySection.vue?vue&type=script&lang=js"
export * from "./DataQualitySection.vue?vue&type=script&lang=js"

import "./DataQualitySection.vue?vue&type=style&index=0&id=4146bb34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4146bb34"]])

export default __exports__